var React = require('react');

function BlogFbBottomInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"44.9545","height":"32","rx":"10","fill":"#2D88FF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.1291 9H15.8253C15.3695 9 15 9.34589 15 9.77266V22.2273C15 22.654 15.3695 23 15.8253 23H22.9877V17.5785H21.0388V15.4656H22.9877V13.9074C22.9877 12.0992 24.1674 11.1145 25.8905 11.1145C26.7159 11.1145 27.4252 11.172 27.6319 11.1977V13.0875L26.4369 13.088C25.4998 13.088 25.3183 13.5048 25.3183 14.1166V15.4656H27.5533L27.2623 17.5785H25.3183V23H29.1291C29.585 23 29.9545 22.654 29.9545 22.2273V9.77266C29.9545 9.34589 29.585 9 29.1291 9Z","fill":"white","key":1})]);
}

BlogFbBottomInline.defaultProps = {"width":"45","height":"32","viewBox":"0 0 45 32","fill":"none"};

module.exports = BlogFbBottomInline;

BlogFbBottomInline.default = BlogFbBottomInline;
